import { IAppState } from '@/interfaces/store-interfaces/app-state.interface';
import { ActionContext } from 'vuex';
import { Vue } from 'vue-property-decorator';
import { ModuleStore } from "@/interfaces/store-interfaces/module-store.interface";
import { pageContentResource } from "@/resources/content-pages.resource";
import { RouterStore } from "@/interfaces/store-interfaces/router-store.interface";
import { ContentPagesStore } from "@/interfaces/store-interfaces/content-pages.interface";
import { contentPagesDataSource } from "@/datasources/content-pages.data-source";
import { detailPageDataSource } from "@/datasources/detail-page.data-source";
import { AppConfig } from "@/app.config";

type StoreActionContext = ActionContext<ModuleStore.IState, IAppState>;

export default {
  namespaced: true,

  state: {
    endpoints: {
      main: '',
      path: '',
      about: '',
      detail: '',
      pathOverview: '',
      dataProtection: '',
      imprint: ''
    }
  },

  mutations: {
    setPropertyInState(state: ModuleStore.IState, { name, value }: { name: string, value: any }) {
      Vue.set(state, name, value);
    },
  },

  actions: {
    async getEndpoints({ state, commit }: StoreActionContext) {
      const endpoint = `${AppConfig.apiUrl}/${ContentPagesStore.ENDPOINTS.ENDPOINT}`;
      try {
        const response = await pageContentResource.getPageContent({ endpoint });
        let url = `${AppConfig.apiUrl}/`;
        commit('setPropertyInState', {
          name: 'endpoints', value: {
            main: url + 'page/' + response.homepage,
            path: url + ContentPagesStore.ENDPOINTS.PATH_PAGE,
            about: url + 'page/' + response.about,
            detail: url + ContentPagesStore.ENDPOINTS.DETAIL_PAGE,
            pathOverview: url + 'page/' + response.themes,
            dataProtection: url + 'page/' + response.data_protection,
            imprint: url + 'page/' + response.imprint
          }
        });

        return response;
      }
      catch (error) {
        console.error(error);
      }
    },

    async getPageContent({ rootState, state, commit, dispatch }: StoreActionContext, { page, id }: { page: RouterStore.ROUTE_NAME, id?: number, }) {
      let response: any = {};
      let params: any = {};
      switch (page) {
        case RouterStore.ROUTE_NAME.MAIN_PAGE:
          params = { endpoint: state.endpoints.main };
          break;

        case RouterStore.ROUTE_NAME.DETAIL_PAGE:
          params = { endpoint: state.endpoints.detail, id };
          break;

        case RouterStore.ROUTE_NAME.PATH_PAGE:
          params = { endpoint: state.endpoints.path, id };
          break;

        case RouterStore.ROUTE_NAME.ABOUT:
          params = { endpoint: state.endpoints.about };
          break;

        case RouterStore.ROUTE_NAME.DATA_PROTECTION:
          params = { endpoint: state.endpoints.dataProtection };
          break;

        case RouterStore.ROUTE_NAME.IMPRINT:
          params = { endpoint: state.endpoints.imprint };
          break;

        case RouterStore.ROUTE_NAME.PATH_OVERVIEW_PAGE:
          params = { endpoint: state.endpoints.pathOverview };
          break;
      }

      response = await pageContentResource.getPageContent(params);

      if (page == RouterStore.ROUTE_NAME.DETAIL_PAGE) {
        response = detailPageDataSource.parse(response);
      } else {
        response = contentPagesDataSource.setBlocksTypes(response);
      }

      return response;
    }
  }
};
